import { useParams } from "react-router-dom";
import { useQuery } from "react-query";
import { getVehicleTypeDetails } from "../../Services/VehicleType";
import BackButton from "../../Components/BackButton";
import { image_url } from "../../Utils/connection_strings";
import "../Dashboard/Dashboard.css";

export default function ViewVehicleType() {
    const { id } = useParams();
    const { data, isLoading } = useQuery(["vehicle_details", id], () => getVehicleTypeDetails(id));
    const vehicle = data?.data?.data?.docs?.[0];

    // Image URL Sanitization
    const getFullImageUrl = (path) => {
        if (!path) return null;
        if (path.startsWith('http')) return path;
        const clean_url = image_url?.endsWith("/") ? image_url.slice(0, -1) : image_url;
        return `${clean_url}/${path.startsWith('/') ? path.slice(1) : path}`;
    };

    const imgPath = vehicle?.vehicleImage || vehicle?.image;
    const preview = imgPath ? getFullImageUrl(imgPath) : null;
    const helperCount = Number(vehicle?.helperCount || 0);

    const vehicleStats = [
        { label: "Type Name", value: vehicle?.name || "N/A" },
        { label: "Base Fare", value: vehicle?.baseFare ? `$${vehicle.baseFare}` : "N/A" },
        {
            label: "Max Capacity",
            value: vehicle?.weight || vehicle?.weightLimit
                ? `${vehicle?.weight || vehicle?.weightLimit} lbs`
                : "N/A",
        },
        {
            label: "Helpers Allowed",
            value: helperCount > 0 ? `${helperCount} Helper${helperCount > 1 ? "s" : ""}` : "None",
        },
        {
            label: "Waiting Duration",
            value: vehicle?.waitingDuration ? `${vehicle.waitingDuration} min` : "N/A",
        },
        {
            label: "Waiting Price",
            value: vehicle?.waitingPrice ? `$${vehicle.waitingPrice}` : "N/A",
        },
        {
            label: "Created On",
            value: vehicle?.createdAt
                ? new Date(vehicle.createdAt).toLocaleDateString()
                : "N/A",
        },
    ];

    const statusClass = vehicle?.active ? "status-active" : "status-inactive";

    return (
        <div className="app-content content dashboard">
            <div className="content-wrapper">
                <div className="content-body">
                    <section id="configuration">
                        <div className="user-details-wrapper">
                            <div className="row mb-4">
                                <div className="col-12">
                                    <div className="back-title d-flex flex-wrap align-items-center justify-content-between gap-3">
                                        <div className="d-flex align-items-center">
                                            <BackButton />
                                            <h1 className="pageTitle m-0 ms-3 fw-800 fs-2">Vehicle Type Details</h1>
                                        </div>
                                        <span className={`status-pill ${statusClass} text-uppercase fw-bold shadow-sm`}>
                                            {vehicle?.active ? "Active" : "Inactive"}
                                        </span>
                                    </div>
                                </div>
                            </div>

                            {isLoading ? (
                                <div className="text-center py-5">
                                    <div className="spinner-border text-primary" role="status"></div>
                                    <p className="mt-3 text-muted">Loading vehicle type details...</p>
                                </div>
                            ) : (
                                <div className="row mb-4 mb-lg-5">
                                    <div className="col-12">
                                        <div className="details-card-premium p-0 overflow-hidden">
                                            <div className="driver-section-header">
                                                <h3 className="driver-docs-title mb-0">Vehicle Type Information</h3>
                                            </div>
                                            <div className="user-profile-body pt-0">
                                                {/* Vehicle Image */}
                                                <div className="driver-docs-section">
                                                    <h4 className="driver-docs-subtitle">Vehicle Image</h4>
                                                    <div className="vt-view-image-wrap">
                                                        {preview ? (
                                                            <img
                                                                src={preview}
                                                                alt={vehicle?.name}
                                                                className="vt-view-image"
                                                                onError={(e) => { e.target.src = 'https://placehold.co/600x400?text=No+Vehicle+Image'; }}
                                                            />
                                                        ) : (
                                                            <div className="vt-view-image-empty">
                                                                <i className="fas fa-truck"></i>
                                                                <span>No Image Uploaded</span>
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {/* Stats Grid */}
                                                <div className="user-profile-stats mb-0 border-0 pt-0">
                                                    {vehicleStats.map((item) => (
                                                        <div key={item.label} className="user-profile-stat">
                                                            <span className="user-profile-stat-label">{item.label}</span>
                                                            <span className="user-profile-stat-value">{item.value}</span>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </section>
                </div>
            </div>

            <style>{`
                .vt-view-image-wrap {
                    max-width: 320px;
                    border: 1px solid #e8edf3;
                    border-radius: 14px;
                    overflow: hidden;
                    background: #f8fafc;
                }
                .vt-view-image {
                    width: 100%;
                    height: auto;
                    display: block;
                    object-fit: contain;
                }
                .vt-view-image-empty {
                    width: 100%;
                    aspect-ratio: 3 / 2;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    gap: 0.5rem;
                    color: #94a3b8;
                }
                .vt-view-image-empty i {
                    font-size: 2rem;
                    opacity: 0.5;
                }
                .vt-view-image-empty span {
                    font-size: 0.82rem;
                    font-weight: 700;
                }
            `}</style>
        </div>
    );
}
